import {
  OperationalScoreWeightKey,
  OperationalScoreWeights,
} from '../types/inventory';

export const DEFAULT_OPERATIONAL_SCORE_WEIGHTS: OperationalScoreWeights = {
  ruptura: 1,
  iminente: 0.8,
  minimo: 0.55,
  critica: 0.35,
  excesso: 0.2,
  sem_venda: 0,
};

export const OPERATIONAL_SCORE_WEIGHT_OPTIONS: Array<{
  key: OperationalScoreWeightKey;
  label: string;
  description: string;
}> = [
  {key: 'ruptura', label: 'Ruptura instalada', description: 'Produto sem estoque.'},
  {key: 'iminente', label: 'Ruptura iminente', description: 'Estoque abaixo da segurança.'},
  {key: 'minimo', label: 'Perto do mínimo', description: 'Estoque entre a segurança e o ponto de pedido, incluindo os limites.'},
  {key: 'critica', label: 'Cobertura crítica', description: 'Cobertura menor que o lead time, ambos arredondados para duas casas decimais.'},
  {key: 'excesso', label: 'Excesso', description: 'Cobertura maior que a cobertura alvo, ambas arredondadas para duas casas decimais.'},
  {key: 'sem_venda', label: 'Sem venda', description: 'Produto sem consumo no período.'},
];

const normalizeWeight = (value: unknown, fallback: number) => {
  if (value === null || value === undefined || value === '') return fallback;
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return fallback;
  return Math.min(1, Math.max(0, numericValue));
};

export function normalizeOperationalScoreWeights(value: unknown): OperationalScoreWeights {
  let source = value;
  if (typeof source === 'string') {
    try {
      source = JSON.parse(source);
    } catch {
      source = null;
    }
  }

  const record = source && typeof source === 'object'
    ? source as Partial<Record<OperationalScoreWeightKey, unknown>>
    : {};

  return OPERATIONAL_SCORE_WEIGHT_OPTIONS.reduce<OperationalScoreWeights>((weights, option) => {
    weights[option.key] = normalizeWeight(
      record[option.key],
      DEFAULT_OPERATIONAL_SCORE_WEIGHTS[option.key],
    );
    return weights;
  }, {...DEFAULT_OPERATIONAL_SCORE_WEIGHTS});
}

export function operationalScoreWeightsEqual(
  left: OperationalScoreWeights,
  right: OperationalScoreWeights,
) {
  return OPERATIONAL_SCORE_WEIGHT_OPTIONS.every(({key}) => left[key] === right[key]);
}
